import { applyVueInReact } from 'vuereact-combined';

import VueAppLoader from '@/components/common/AppLoader.vue';

const ReactAppLoader = applyVueInReact(VueAppLoader);

const AppLoader = (props: unknown) => {
	const propsToPass = props ? { ...props } : {};
	return <ReactAppLoader {...propsToPass} />;
};

export default AppLoader;
